import React from 'react';
import { Route } from '../Routing/types';
import { MeasurementsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/measurements/*',
    element: <MeasurementsPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('measurements.navbarTitle'),
    mobileAppTabIdentifier: 'measurements',
    descendantRoutes,
  },
];

export default routes;
